/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import React from 'react';
// @ts-ignore
import {ParseCategoryIds,GeneralAssetUrl, HeaderHeight, MobileHeaderHeight} from "./../../themes/kent/utilities/constants";
// @ts-ignore
import {GetLocalizedText,GetLocalText,GetExternalProductId, GetExternalProductInfo,GenerateProductAssetUrl,DoesProductShowHeroImage} from "./../../themes/kent/utilities/functions";
// @ts ignore
import animateScrollTo from 'animated-scroll-to';

interface IState {
  imageReady:boolean,
  ready:boolean;
  title:string;
  tagline:string;
  buttonText:string;
  shown?: any;
}

interface IProps {
  product?: any;
  year?:any;
  category?:any;
  subcategory?:any;
}

/**
 *
 * Hero component
 * @extends {React.Component<IHosportsProductDetailHeroViewProps<IHeroData>>}
 */
class HosportsProductDetailHero extends React.Component<IProps,IState> {

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      imageReady:false,
      ready:false,
      title:"",
      tagline:"",
      buttonText:"",
    };
  }

  public componentWillMount = async () => {
    let product = this.props.product;
    if(product){
      let shown = await DoesProductShowHeroImage(this.props.product,this.props.category,this.props.subcategory)
      if(shown){
        this.fillModule(product)
      }
    }
  }
  public fillModule = async (product:any) =>{
    if(product){
      if(product.attributes){
        let title:any = GetLocalizedText(product.attributes.content,"title");
        let tagline:any = GetLocalizedText(product.attributes.content,"tagline");
        let buttonText:any = await GetLocalText('buyNowText');

        this.setState({
          shown:true,
          title:title,
          tagline:tagline,
          buttonText:buttonText,
        })
      }
    }
  }

  public imageLoaded = () =>{
    this.setState({
      imageReady:true
    })
  }
  public scrollDown = () =>{
    // @ts-ignore
    animateScrollTo(document.querySelector('.hero-scroll-catch'));
  }

  public render(): JSX.Element {
    let prodAssetUrl:string = GenerateProductAssetUrl(this.props.year);
    let product = this.props.product;
    let image = undefined;
    let type = undefined;
    let productIncluded = this.state.shown;
    if(product){
      image = prodAssetUrl+product.attributes.slug+'-hero.jpg'
      type = "";

      if(this.props.product.attributes.slug == "ballast-M6002" || this.props.product.attributes.slug == "ballast-M6003" || this.props.product.attributes.slug == "ballast-fat-weight"){
        type = 'ballast'
      }
      if(product.attributes.slug.indexOf('wakeboard-vests') != -1 ){
        type = 'wakeboard-vests'
      }
      if(product.attributes.slug.indexOf('wakeboards') != -1 ){
        type = 'wakeboards'
      }
      if(product.attributes.slug.indexOf('wakeboard-boots') != -1 ){
        type = 'wakeboard-boots'
      }
      if(product.attributes.slug.indexOf('wakesurfers') != -1 ){
        type = 'wakesurfers'
      }
      if(product.attributes.slug.indexOf('waterskis') != -1 ){
        type = 'waterskis'
      }
    }


    let activeClass = "";
    if(this.state.imageReady){
      activeClass = 'active'
    }
    let spacer = HeaderHeight;
    let backgroundColor = "#000";
    if(window.innerWidth < 800){
      spacer = MobileHeaderHeight;
    }
    let customHeroDescriptionColor = '#fff';
    if(product.attributes.customHeroColor){
      customHeroDescriptionColor = product.attributes.customHeroColor
    }
    if(!productIncluded) return <div style={{height:spacer, width:"100%", backgroundColor:backgroundColor}}/>;
    return (
      <div className={"product-detail-hero-outer black-background "+activeClass}>
        <div className={"product-detail-hero-container " +type}>
          <img className="product-detail-hero" src={image} onLoad={this.imageLoaded} />
          <div className={"product-detail-hero-overlay"}>
            <h2 className="white decorative-text">{this.state.title}</h2>
            <h5 className="white subheading" style={{color:customHeroDescriptionColor}}>{this.state.tagline}</h5>
            {/* <div className="product-detail-hero-buy-button" onClick={this.scrollDown}>{this.state.buttonText}</div> */}
          </div>
          <div className={"product-detail-hero-down-button "} onClick={this.scrollDown}>
            <img className="full-width" src={GeneralAssetUrl+'down-white.png'} />
          </div>
          <div className="hero-scroll-catch"></div>
        </div>
      </div>
    );
  }
}

export default HosportsProductDetailHero;
